export const configureSVGAccessibility = (svg, altText) => {
  svg.setAttribute("role", "img")
  if (altText) {
    svg.setAttribute("aria-label", altText)
  } else {
    svg.setAttribute("aria-hidden", "true")
  }
}
